"use client";

import { ArrowUp, Facebook, Linkedin, Twitter } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
        <div className="h-4 w-20 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-foreground/80 hover:text-secondary transition-colors text-sm font-default">
          {item.label}
        </Link>)}
    </nav>;
}
function FooterMenuWrapper() {
  return <MenuProvider menu_id="41">
      <FooterMenuContent />
    </MenuProvider>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  return <section data-section-id="264699" id="footer" className="bg-background text-foreground border-t border-border">
      {}
      <div className="mx-auto max-w-7xl px-4 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {}
          <div className="flex flex-col gap-4">
            <Link to="/HomePage" className="inline-flex">
              <WvcLogo className="h-8 w-auto text-secondary" />
            </Link>
            <p className="text-foreground/70 text-sm leading-relaxed font-default">
              Providing elite mortgage solutions with the precision and prestige you deserve. Your path to home ownership starts here.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground text-lg">
              Quick Links
            </h3>
            <FooterMenuWrapper />
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground text-lg">
              Company
            </h3>
            <nav className="flex flex-col gap-3">
              <Link to="/AboutUsPage" className="text-foreground/80 hover:text-secondary transition-colors text-sm font-default">
                About Us
              </Link>
              <Link to="/LoanOptionsPage" className="text-foreground/80 hover:text-secondary transition-colors text-sm font-default">
                Loan Options
              </Link>
              <Link to="/ContactPage" className="text-foreground/80 hover:text-secondary transition-colors text-sm font-default">
                Contact
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default font-semibold text-foreground text-lg">
              Contact Us
            </h3>
            <div className="flex flex-col gap-2 text-sm text-foreground/70">
              <p className="font-default">123 Prestige Way, Financial District</p>
              <Link to="tel:+18005550199" className="hover:text-secondary transition-colors font-default">
                (800) 555-0199
              </Link>
              <Link to="mailto:concierge@premierhomeloans.com" className="hover:text-secondary transition-colors font-default">
                concierge@premierhomeloans.com
              </Link>
            </div>
            <div className="flex gap-3 pt-2">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} className="w-9 h-9 rounded-md border border-border hover:border-secondary hover:bg-secondary/10 flex items-center justify-center text-foreground transition-all shadow-sm" aria-label={social.label}>
                    <Icon className="w-4 h-4" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="flex justify-end mb-8">
          <Button onClick={scrollToTop} variant="ghost" size="icon" className="border border-border hover:bg-secondary/10 hover:text-secondary rounded-md shadow-md transition-all" aria-label="Back to top">
            <ArrowUp className="w-4 h-4" />
          </Button>
        </div>
      </div>

      {}
      <Separator className="bg-border" />
      <div className="mx-auto max-w-7xl px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p className="font-default">
            &copy; 2024 Premier Home Loans. All rights reserved. NMLS #123456.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-secondary transition-colors font-default">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-secondary transition-colors font-default">
              Terms of Service
            </Link>
            <Link to="#" className="hover:text-secondary transition-colors font-default">
              Licensing
            </Link>
          </div>
        </div>
      </div>
    </section>;
}